import { API_URLS } from "@/constants/urls"
import { apiClient } from "./apiClient"
import { formatDateYMD } from "@/helpers/formatters"

export const dashboardServices = {
    getMarketInsights: async (compsetId) => {
        const result = await apiClient.get(API_URLS.MARKET_INSIGHTS(compsetId))
        return result.data
    },
    getRateParity: async (compsetId) => {
        const result = await apiClient.get(API_URLS.RATEPARITY(compsetId))
        return result.data
    },
    getPricingOpportunity: async (compsetId) => {
        const result = await apiClient.get(API_URLS.PRICING_OPPORTUNITY(compsetId))
        return result.data
    },
    getCompetitiveAnalysis: async (compsetId) => {
        const result = await apiClient.get(API_URLS.COMPETITIVE_ANALYSIS(compsetId))
        return result.data
    },
    getAdvancedAnalysis: async (compsetId) => {
        const result = await apiClient.get(API_URLS.ADVANCED_ANALYSIS(compsetId))
        return result.data
    },
    getDemandsEvents: async (compsetId) => {
        const result = await apiClient.get(API_URLS.DEMANDS_EVENTS(compsetId), {
            params: {
                days: 30
            }
        })
        return result.data
    },
    getRateparityOfficialSiteInfo: async (compsetId) => {
        const result = await apiClient.get(API_URLS.RATE_PARITY_OFFICIAL_SITE(compsetId))
        return result.data
    },
    getAllAiInsights: async (compsetId) => {
        const result = await apiClient.get(API_URLS.ALL_AI_INSIGHTS(compsetId))
        return result.data
    }
}

export const compsetServices = {
    getCompsets: async () => {
        const result = await apiClient.get(API_URLS.COMPSETS)
        return result.data
    }
}

export const userServices = {
    getUserDetails: async () => {
        const result = await apiClient.get(API_URLS.PROFILE)
        return result.data
    }
}

export const reportServices = {
    generateReport: async ({ start, end, reportType, r_id }) => {
        const res = await apiClient.get(API_URLS.GENERATE_REPORT, {
            params: {
                report_type: reportType,
                from: formatDateYMD(start),
                to: formatDateYMD(end),
                r_id
            }
        });
        return res.data;
    },
    exportAnalysisData: async (compsetId) => {
        const result = await apiClient.get(API_URLS.EXPORT_ANALYSIS(compsetId))
        return result.data
    }
}

export const paymentServices = {
    getPlanDetails: async () => {
        const result = await apiClient.get(API_URLS.PLAN_DETAILS)
        return result.data
    },
    getPlanRules: async () => {
        const result = await apiClient.get(API_URLS.PLAN_RULES)
        return result.data
    }
}
